export default {
  improvementplans: {
    title: '改善計画',
    high: '高',
    middle: '中',
    low: '低',
    exceed: '超過',
    policy: '規範・方針',
    measure: '施策',
    result: '結果',
    currently_supporting: '対応中',
    completion: '完了',
    ended: '終了(未対応)',
    risk: 'リスク度',
    thema: "@:{'common.esg.category'}",
    improvement_plan: '改善計画',
    deadline_for_completion: '完了期限',
    message_count: 'メッセージ',
    operation: '操作',
    detail: "@:{'common.scorecard.detail'}",
    indicator: '指標',
    indicator_point: '改善点',
    buyer_indicator_point: '評価コメント',
    status: 'ステータス',
    supported: '対応済',
    unsupported: '未対応',
    progress: '進捗状況',
    advice: {
      text_line_1: '今回の評価から、より良いESGの取り組みを進めましょう。',
      text_line_2: "改善点の@:{'common.esg.category'}や内容を確認し、「改善計画を作成」から",
      text_line_3: '取り組み内容や完了期日を設定することができます。',
      text_line_4: '改善計画を立て、次の評価に向けて取り組んでいきましょう。',
      text_line_5: '進捗状況は左のグラフで確認することができます。',
      text_line_6: '再評価を依頼する場合は、',
      contact: 'お問い合わせ',
      please_contact_us: 'にてご相談ください。',
    },
    sub_section_title_1: '対応中の改善計画',
    no_data_display: '表示できるデータはありません。',
    sub_section_title_2: '未対応の改善点',
    buyer_sub_section_title_2: '未対応の評価コメント',
    operation_link_text: '改善計画を作成',
    add_advice: '改善点の追加',
    sub_section_title_3: '対応済の改善点',
    buyer_sub_section_title_3: '対応済の評価コメント',
    revaluation_request: '再評価依頼',
    cautionary_note: '完了した改善計画を踏まえて、再評価を依頼しますか？',
    asterisked_text: '※再評価を依頼するには、お問い合わせ画面から別途お申し込みが必要となります。',
    submit_btn_text: '再評価を依頼する',
    table_state: 'tableState',
    select_a_file: 'ファイルを選択',
    attached_file: '添付ファイル',
    notes: '備考',
    created_improvement_plan: '改善計画を作成しました。',
    error_file_upload: 'ファイルアップロードによるエラーが発生しました。',
    failed_to_create: '改善計画の作成に失敗しました。画面を再読み込みしてお試しください。',
    no_data_found: '改善点のデータは見つかりませんでした。',
    file_upload: {
      filesize_max: '10MB以下のファイルを選択してください。',
      max_files: 'アップロードは最大10件です。',
      confirmation_of_deletion: 'このファイルを削除しますか？',
    },
    create_improvement_plan: '改善計画を作成する',
    no_data_improvement_plan: '対応が必要な改善計画は現在ありません。',
  },
  buyer_improvementplans: {
    flag: 'フラグ',
    memo: 'メモ',
    flag_on: 'フラグをつける',
    flag_off: 'フラグをはずす',
    panel: {
      title: '企業情報・メモ',
      company_memo: '社内メモ',
      latest_memo: '最新のメモ',
      no_memo: 'メモはまだありません。',
      check_list: '一覧を確認',
      memo_list: 'メモ一覧',
      no_assignee: '担当者なし',
      assignee_select_box: {
        assignee: '社内担当者',
        placeholder: '担当者を選択',
        create_member: '社内担当者を追加',
      },
      create_member_modal: {
        title: '社内担当者を追加する',
        label: '社内担当者名',
        place_holder: '社内担当者名を入力してください',
      },
      delete_member_modal: {
        title: '社内担当者削除確認',
        confirm_text: 'この社内担当者を削除してよろしいですか？',
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: '一覧に戻る',
    action_cases: '対応件数',
    no_improvements: '改善点はありません',
    confirm_delete_memo: '社内メモ1件を削除しますか？',
    confirm_delete_memo_title: '社内メモを削除する',
    display_only_is_marked: 'フラグ付きのみ表示',
    create_memo: 'メモを作成',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
